import { makeStyles, tokens } from '@fluentui/react-components';
import { px } from '@this/app-shared/dist/tools/styles.js';

export const useSharedStyles = makeStyles({
    // dropdown
    dropdown: {
        borderBottomColor: tokens.colorNeutralStroke1,
        minWidth: '100%',
        maxWidth: '100%',
    },
    dropdownListbox: {
        maxHeight: px(768),
    },
    // input
    input: {
        margin: px(0),
        paddingInlineEnd: tokens.spacingVerticalXXS,
        width: '100%',
    },
});
